import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import LoginMain from "./LoginMain";
import Footer from "../../components/Footer";

const Login = () => {
  return (
    <>
      <HeaderFour />

      <LoginMain />

      <Footer />
    </>
  );
};

export default Login;
